import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Tooltip, Glyphicon, OverlayTrigger } from 'react-bootstrap';
import _ from 'underscore';
import { humanize, capitalize, camelize, titleize } from 'underscore.string';
import CargomaticCollapsibleCard from 'components/v2/CollapsibleCard';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import ItemAlt from 'components/ui/tailwind/ItemAlt';
import OrderWebAPIUtils from 'utils/OrderWebAPIUtils';
import { withTranslation, Translation } from 'react-i18next';
import { weightUnitsOptions, temperatureUnitsOptions, } from 'utils/localization/types';
import OrdersActionCreators from 'actions/OrdersActionCreators';
const serviceTypes = [
    {
        localizationSlug: 'LIVE_LOAD_UNLOAD',
        name: 'Live Load/Unload',
        value: 'live',
    },
    {
        localizationSlug: 'DROP_HOOK',
        name: 'Drop & Hook',
        value: 'drop',
    },
];
const movementTypes = [
    {
        localizationSlug: 'PICKUP',
        name: 'Pickup',
        value: 'pickup',
    },
    {
        localizationSlug: 'DELIVERY',
        name: 'Delivery',
        value: 'delivery',
    },
];
const orderTypes = [
    {
        localizationSlug: 'IMPORT',
        name: 'Import',
        value: 'import',
    },
    {
        localizationSlug: 'EXPORT',
        name: 'Export',
        value: 'export',
    },
];
const modeTypes = [
    {
        localizationSlug: 'DRAYAGE',
        name: 'Drayage',
        value: 'drayage',
    },
    {
        localizationSlug: 'INTERMODAL',
        name: 'Intermodal',
        value: 'intermodal',
    },
];
function formatDate(date, t) {
    return date ? moment(date).format('L') : t('NOT_SET');
}
const TOOLTIPS = {
    editModeDisabled: (React.createElement(Tooltip, { id: "edit-disabled-tooltip" },
        React.createElement(Translation, null, (t, { i18n }) => React.createElement("p", null, t('EDIT_MODE_DISABLED_TIP'))))),
};
class InboundDetails extends Component {
    constructor(props) {
        var _a, _b;
        super(props);
        this.handleOnChangeRailRoadMultiSelect = (selected) => {
            if (Array.isArray(selected)) {
                this.setState({ railroads: selected === null || selected === void 0 ? void 0 : selected.map(({ value }) => value) });
            }
        };
        this.handleOnChangeCustomRailRoadOption = (value) => {
            this.setState((prev) => ({
                railRoadItems: [...prev.railRoadItems, { value, label: value }],
            }));
        };
        this.state = { railroads: (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.order) === null || _b === void 0 ? void 0 : _b.railroads };
    }
    componentDidMount() {
        this.retrieveOceanScacs();
        this.retriveRailRoadItems();
    }
    retriveRailRoadItems() {
        const railRoadOptions = [
            { label: 'BNSF', value: 'BNSF' },
            { label: 'CN', value: 'CN' },
            { label: 'CPKC', value: 'CPKC' },
            { label: 'CSX', value: 'CSX' },
            { label: 'FCCM', value: 'FCCM' },
            { label: 'FEC', value: 'FEC' },
            { label: 'FSR', value: 'FSR' },
            { label: 'FXE', value: 'FXE' },
            { label: 'NDM', value: 'NDM' },
            { label: 'NS', value: 'NS' },
            { label: 'UP', value: 'UP' },
            { label: 'UTFM', value: 'UTFM' },
        ];
        this.setState({ railRoadItems: railRoadOptions });
    }
    async retrieveOceanScacs() {
        const ocean_scacs = await OrderWebAPIUtils.getCarrierScacs();
        if (ocean_scacs) {
            this.setState({
                ocean_scacs: ocean_scacs.OCEAN_SCAC_CODES.map((scac) => ({
                    name: scac.carrier,
                    value: scac.ocean_scac,
                })),
            });
        }
    }
    renderMultiSelectField(field, value, label, items, placeholderText, onChangeMultiSelect, allowCustom, onChangeCustom, customOptionLabel, addCustomLabel) {
        const { t } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(DescriptionListItem, { label: t(label), dataTestId: field },
                React.createElement(ItemAlt, { name: field, type: "multi-select", menuItems: items, value: value, displayValue: value === null || value === void 0 ? void 0 : value.join(','), displayClass: "max-w-[140px] break-words", editable: true, onValueSave: this.props.onEdit, onValueCancel: () => {
                        var _a, _b;
                        this.setState({ railroads: (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.order) === null || _b === void 0 ? void 0 : _b.railroads });
                    }, placeholderText: placeholderText, allowCustom: allowCustom, onChange: onChangeMultiSelect, customOptionLabel: customOptionLabel, addCustomLabel: addCustomLabel, onCustomValueAdd: onChangeCustom }))));
    }
    renderDropdownField(field, value, label, items, displayFunc, type) {
        const { t } = this.props;
        return (React.createElement(DescriptionListItem, { label: t(label), className: "mb-3", dataTestId: field },
            React.createElement(ItemAlt, { name: field, type: type || 'dropdown', menuItems: items, localizationKey: "localizationSlug", displayValue: displayFunc, value: value, editable: true, onValueSave: this.props.onEdit, glyphClass: "float-left cursor-pointer mb-1" })));
    }
    renderDropdownWithInput(field, value, label, items, displayValue, renderConditionalField = true) {
        const { t } = this.props;
        return (React.createElement(DescriptionListItem, { label: t(label), className: "mb-3", dataTestId: field },
            React.createElement(ItemAlt, { name: field, type: "dropdown_with_input", menuItems: items, displayValue: displayValue, value: value, renderConditionalField: renderConditionalField, editable: true, onValueSave: this.props.onEdit, glyphClass: "float-left cursor-pointer mb-1" })));
    }
    renderField(field, type, label, formatter) {
        const { order, t } = this.props;
        let displayValue = null;
        if (field === 'reefer_temperature' && Number.isNaN(order[field])) {
            formatter = null;
        }
        if (type === 'date') {
            displayValue = formatDate(order[field], t);
        }
        else if (formatter) {
            displayValue = formatter(order[field]);
        }
        let heapClass = '';
        if (type && field && type === 'date') {
            heapClass = 'order-orderDetails-edit' + camelize(field) + ' heap';
        }
        let maxLength;
        if (field === 'special_instructions')
            maxLength = 500;
        return (React.createElement(DescriptionListItem, { label: titleize(t(label, { count: 1 })), className: "mb-3", dataTestId: field },
            React.createElement(ItemAlt, { name: field, type: type, value: order[field], displayValue: displayValue, editable: true, onValueSave: this.props.onEdit, glyphClass: "float-left cursor-pointer mb-1", saveButtonClass: `button button-green ${heapClass}`, maxLength: maxLength })));
    }
    renderExportDateFields() {
        const { order: { order_type }, } = this.props;
        if (order_type !== 'export') {
            return null;
        }
        return (React.createElement("div", null,
            this.renderField('last_free_date', 'date', 'LAST_CUT_DATE'),
            this.renderField('earliest_return_date', 'date', 'EARLIEST_RETURN_DATE'),
            this.renderField('earliest_empty', 'date', 'EARLIEST_DATE_TO_GET_EMPTY')));
    }
    renderImportDateFields() {
        const { order: { order_type }, } = this.props;
        if (order_type !== 'import') {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            this.renderField('last_free_date', 'date', 'LAST_FREE_DATE'),
            this.renderField('arrival_date', 'date', 'ARRIVAL_DATE'),
            this.renderField('estimated_arrival', 'date', 'ESTIMATED_ARRIVAL_DATE')));
    }
    getCustomScacData(order) {
        const { ocean_scacs } = this.state;
        const { ocean_carrier_scac } = order;
        const scacKeys = (ocean_scacs || []).map((scac) => scac.name);
        const renderScacInput = (ocean_carrier_scac !== undefined || ocean_carrier_scac !== '') &&
            !scacKeys.includes(ocean_carrier_scac);
        const customScacInput = (ocean_scacs || []).find((scac) => scac.value === ocean_carrier_scac);
        return {
            renderScacInput,
            customScacValue: !_.isEmpty(customScacInput) ? customScacInput.value : '',
            customScacInput: !_.isEmpty(customScacInput) && customScacInput.name !== 'Custom'
                ? customScacInput.name
                : ocean_carrier_scac,
        };
    }
    render() {
        var _a, _b, _c, _d;
        const order = this.props.order;
        const originating = (order === null || order === void 0 ? void 0 : order.originating) && (order === null || order === void 0 ? void 0 : order.originating.length) > 0
            ? order === null || order === void 0 ? void 0 : order.originating[0].address
            : '';
        const modeDisabled = (order === null || order === void 0 ? void 0 : order.shipments.length) > 0 &&
            (order === null || order === void 0 ? void 0 : order.shipments.some((shipment) => shipment.shipment_type === 'rail'));
        const scacData = this.getCustomScacData(order);
        const { railroads, railRoadItems } = this.state;
        const { t } = this.props;
        return (React.createElement(CargomaticCollapsibleCard, { id: "order-details", header: () => React.createElement("span", null, t('ORDER_DETAILS')) },
            React.createElement("div", { className: "grid grid-cols-2 grid-gap-6" },
                React.createElement(DescriptionListItem, { label: t('ORDER_TYPE'), className: "mb-3", dataTestId: "order-type-kv" },
                    React.createElement(ItemAlt, { name: "order_type", type: "dropdown", menuItems: orderTypes, localizationKey: "localizationSlug", displayValue: t((_a = order === null || order === void 0 ? void 0 : order.order_type) === null || _a === void 0 ? void 0 : _a.toUpperCase()), value: order === null || order === void 0 ? void 0 : order.order_type, editable: false, onValueSave: this.props.onEdit, glyphClass: "float-left cursor-pointer mb-1" })),
                React.createElement(DescriptionListItem, { label: titleize(t('MODE')), className: "mb-3", dataTestId: "order-mode-kv" },
                    modeDisabled && (React.createElement("div", { className: "" },
                        React.createElement("span", { className: "mr-2" }, capitalize((order === null || order === void 0 ? void 0 : order.mode) || '')),
                        React.createElement(OverlayTrigger, { placement: "top", overlay: TOOLTIPS.editModeDisabled, style: { display: 'inline-block' } },
                            React.createElement(Glyphicon, { glyph: "info-sign" })))),
                    !modeDisabled && (React.createElement(ItemAlt, { name: "mode", type: "dropdown", menuItems: modeTypes, localizationKey: "localizationSlug", displayValue: t((_b = order === null || order === void 0 ? void 0 : order.mode) === null || _b === void 0 ? void 0 : _b.toUpperCase()), value: order === null || order === void 0 ? void 0 : order.mode, editable: true, onValueSave: this.props.onEdit, glyphClass: "float-left cursor-pointer mb-1" }))),
                React.createElement(DescriptionListItem, { label: t('SERVICE_TYPE'), className: "mb-3", dataTestId: "order-service-type-kv" },
                    React.createElement(ItemAlt, { name: "service_type", type: "dropdown", localizationKey: "localizationSlug", menuItems: serviceTypes, displayValue: t((_c = _.findWhere(serviceTypes, {
                            value: order === null || order === void 0 ? void 0 : order.service_type,
                        })) === null || _c === void 0 ? void 0 : _c.localizationSlug), value: order === null || order === void 0 ? void 0 : order.service_type, editable: true, onValueSave: this.props.onEdit, glyphClass: "float-left cursor-pointer mb-1" })),
                React.createElement(DescriptionListItem, { label: t('MOVEMENT_TYPE'), className: "mb-3", dataTestId: "order-movement-type-kv" },
                    React.createElement(ItemAlt, { name: "movement_type", type: "dropdown", localizationKey: "localizationSlug", menuItems: movementTypes, displayValue: humanize(order === null || order === void 0 ? void 0 : order.movement_type), value: order === null || order === void 0 ? void 0 : order.movement_type, editable: true, onValueSave: this.props.onEdit, glyphClass: "float-left cursor-pointer mb-1" })),
                this.renderField('total_weight', 'number', 'TOTAL_WEIGHT'),
                this.renderField('certified_weight', 'number', 'CERTIFIED_WEIGHT'),
                React.createElement(DescriptionListItem, { label: t('WEIGHT_UNIT'), className: "mb-3", dataTestId: "order-weight-unit-kv" },
                    React.createElement(ItemAlt, { name: "weight_units", type: "dropdown", localizationKey: "localizationSlug", menuItems: weightUnitsOptions, displayValue: order === null || order === void 0 ? void 0 : order.weight_units, value: order === null || order === void 0 ? void 0 : order.weight_units, editable: true, onValueSave: this.props.onEdit, glyphClass: "float-left cursor-pointer mb-1" })),
                this.renderField('count', 'number', 'COUNT'),
                this.renderField('reefer_temperature', 'string', 'REEFER_TEMPERATURE'),
                React.createElement(DescriptionListItem, { label: t('REEFER_TEMPERATURE_UNIT'), className: "mb-3", dataTestId: "reefer-temperature-kv" },
                    React.createElement(ItemAlt, { name: "reefer_temperature_unit", type: "dropdown", localizationKey: "localizationSlug", disableTitleize: true, menuItems: temperatureUnitsOptions, displayValue: t((_d = _.findWhere(temperatureUnitsOptions, {
                            value: order === null || order === void 0 ? void 0 : order.reefer_temperature_unit,
                        })) === null || _d === void 0 ? void 0 : _d.localizationSlug), value: order === null || order === void 0 ? void 0 : order.reefer_temperature_unit, editable: true, onValueSave: this.props.onEdit, glyphClass: "float-left cursor-pointer mb-1" })),
                this.renderField('beneficial_cargo_owner', 'string', 'BENEFICIAL_CARGO_OWNER'),
                React.createElement(DescriptionListItem, { label: t('ORIGINATING'), className: "mb-3", dataTestId: "order-originating-kv" },
                    React.createElement(ItemAlt, { name: "originating", type: "address", value: originating || '', editable: true, onValueSave: (loc) => {
                            const update = {
                                address: loc.originating,
                            };
                            OrdersActionCreators.updateOrder(order === null || order === void 0 ? void 0 : order._id, {
                                originating: update,
                            });
                        }, glyphClass: "float-left cursor-pointer mb-1" })),
                React.createElement("div", null, this.state.ocean_scacs &&
                    this.state.ocean_scacs.length &&
                    this.renderDropdownWithInput('ocean_carrier_scac', scacData.customScacValue, 'STEAMSHIP', this.state.ocean_scacs, scacData.customScacInput, scacData.renderScacInput)),
                React.createElement("div", null, this.renderMultiSelectField('railroads', railroads, t('RAILROADS'), railRoadItems, t('RAILROADS'), this.handleOnChangeRailRoadMultiSelect, true, this.handleOnChangeCustomRailRoadOption, t('CUSTOM_RAILROADS'), t('ADD_CUSTOM_RAILROAD'))),
                this.renderField('vessel_or_rail', 'string', 'VESSEL'),
                this.renderField('train', 'string', 'TRAIN'),
                this.renderImportDateFields(),
                this.renderExportDateFields(),
                this.renderField('special_instructions', 'string', 'SPECIAL_INSTRUCTIONS'),
                this.renderField('cargo_description', 'string', 'CARGO_DESCRIPTION'))));
    }
}
InboundDetails.propTypes = {
    order: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
};
export default withTranslation()(InboundDetails);
